import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/port";
import l10n from "../../../l10n/localization";
import * as creationActions from "../../../actions/creation";
import PortForm from "../PortForm";
import {Button} from "react-materialize";

class SelectPorts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    onChange(value) {
        if(value === 0){
        } else {
            this.props.onChange(value);
        }
    }

    render() {
        return (
            <div className="form-group field">
                <Button type="button" floating onClick={() => this.props.schema.openDrawer(PortForm, null, creationActions.destroyingnewlyCreatedPort())} icon="add" className="add-button btn-md ml5"/>

                <label className="control-label" htmlFor="root_port">
                    {l10n.fog.port}
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_port"
                    value={this.props.formData}
                    options={utils.portToSelect(this.props.ports)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                    <div className="pull-right mr25 input-button-wrapper">
                                        <i>
                                            <Button type="button" floating onClick={() => this.props.schema.openDrawer(PortForm, {item: props.value.item}, creationActions.destroyingnewlyCreatedPort())} icon="edit" className="edit-button small"/>
                                        </i>
                                    </div>
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        ports: state.port.ports,
        loading: state.port.loading
    });
})(SelectPorts);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectPorts.js